import { render, staticRenderFns } from "./Artikli.vue?vue&type=template&id=d6866ca6&scoped=true&"
import script from "./Artikli.vue?vue&type=script&lang=ts&"
export * from "./Artikli.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6866ca6",
  null
  
)

export default component.exports